import "./searchable-list.scss";
import m from "mithril";
import pf from "../../../old/pf";
import {Checkbox} from "../../../old/tools/constructui";

export default () => {
	let searchtext = undefined;
	let selectedvalues = [];
	return {
		oninit: ({attrs: {values}}) => {
			selectedvalues = values || [];
			// console.log(selectedvalues)
		},
		view: ({attrs: {list_id_caption, multiselect, rendermethod, searchmethod, onchange, maxcount}}) => {
			// console.log("redrawn", selectedvalues);
			return m(".searchable-list-container", [
				m("input.search-box", {
					autofocus: true,
					style: `width: 100%;`,
					value: searchtext,
					oninput: (e) => {
						console.log("searched", e);
						searchtext = e.target.value;
					},
				}),
				m(".searchable-list", [
					list_id_caption
						.filter((o) => {
							if (searchtext)
								return searchmethod ? searchmethod(o, searchtext) : pf.regexContains(o.caption, searchtext);
							else return true;
						})
						.map((o) => {
							return m(
								".searchable-item",
								m(Checkbox, {
									style: "width: 100%;",
									checked: selectedvalues.find((a) => a.id == o.id),
									label: rendermethod ? rendermethod(o) : o.caption,
									onchange: (e) => {
										if (e.target.checked) {
											if (maxcount == 1) {
												selectedvalues = [o];
											} else {
												if (maxcount > 0 && selectedvalues.length >= maxcount) {
													alert(`You can only select a maximum of ${maxcount} items`);
													e.target.checked = false;
												} else selectedvalues.push(o);
											}
										} else selectedvalues = selectedvalues.filter((t) => t.id != o.id);
										if (onchange) onchange(selectedvalues);
									},
								})
							);
						}),
				]),
			]);
		},
	};
};
